import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { apiGetOrgunits } from "../../../api/ApiOrgunit";
import { apiGetProcess, apiSaveProcess, apiUpdateProcess } from "../../../api/ApiProcess";
import { selectReduxInstance } from "../../../redux/ReduxInstance";
import { useTranslation } from "react-i18next";

const ModalCreateUpdate = (props) => {
  const { t } = useTranslation();
  const initialState = {
    nom: "",
    description: "",
    risk: "",
    indicator: "",
    owner: null,
    famille: props.forceMacro ? "MacroProcess" : null,
    orgunits: [],
  };
  const { id, show, handleClose, handleRecupDatas } = props;
  const [state, setState] = useState(initialState);
  const ReduxInstance = useSelector(selectReduxInstance);
  const [orgunits, setOrgunits] = useState([]);

  const recupData = async () => {
    const res = await apiGetProcess(ReduxInstance._id, id);
    if (res) {
      setState(res.data);
    } else {
      console.log("error");
    }
  };

  const recupOrgunits = async () => {
    const res = await apiGetOrgunits(ReduxInstance._id);
    if (res) {
      setOrgunits(res.data);
    } else {
      console.log("error");
    }
  };

  useEffect(() => {
    recupOrgunits();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (id) recupData();
    else setState(initialState);
  }, [id, show]); // eslint-disable-line react-hooks/exhaustive-deps

  const submitData = async () => {
    if (id) {
      await apiUpdateProcess(id, state);
      handleRecupDatas();
    } else {
      const res = await apiSaveProcess(ReduxInstance._id, state);
      if (res) {
        if (!props.forceMacro) {
          props.handelAddProcess(res.data);
        }
        handleRecupDatas();
      }
    }
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      {/* <pre>{JSON.stringify(state, null, 4)}</pre> */}
      <Modal.Header closeButton>
        <Modal.Title>
          {id
            ? t("admin.PageAdminProcesses.modaCreateUpdateTitre2")
            : t("admin.PageAdminProcesses.modaCreateUpdateTitre1")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <label className="mt-2">{t("commun.form.label.intitule1")}</label>
          <Form.Control
            type="text"
            name="nom"
            placeholder={t("commun.form.placeholder.placeholder1")}
            value={state.nom}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />
          <label className="mt-2">{t("commun.form.label.description")}</label>
          <Form.Control
            type="text"
            name="description"
            placeholder={t("commun.form.placeholder.description")}
            value={state.description}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />
          <label className="mt-2">{t("commun.form.label.risque")}</label>
          <Form.Control
            type="text"
            name="risk"
            placeholder={t("commun.form.placeholder.risque")}
            value={state.risk}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />
          <label className="mt-2">{t("commun.form.label.indicateur")}</label>
          <Form.Control
            type="text"
            name="indicator"
            placeholder={t("commun.form.placeholder.indicateur")}
            value={state.indicator}
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
          />
          <label className="mt-2">{t("commun.form.label.proprietaire")}</label>
          <Form.Select
            value={state.owner == null ? "" : state.owner}
            name="owner"
            aria-label="Propriétaire"
            onChange={(e) => setState({ ...state, [e.target.name]: e.target.value || null })}
          >
            <option value="">{t("commun.form.placeholder.proprietaire")}</option>
            {orgunits.map((orgunit, key) => (
              <option key={key} value={orgunit._id}>
                {orgunit.enSommeil
                  ? "⚠ " + t("admin.PageAdminOrgunits.titreColonne9") + " ⚠ - "
                  : ""}
                {orgunit.nom}
              </option>
            ))}
          </Form.Select>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          {t("commun.form.button.annuler")}
        </Button>
        <Button variant="success" onClick={submitData}>
          {id ? t("commun.form.button.modifier") : t("commun.form.button.ajouter")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCreateUpdate;
